import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { isJapanese } from '../../../utils/lang';
import ExternalLink from './ExternalLink';

/**
 * プライバシーポリシーに関するANA公式ページへのリンクのコンポーネント。
 */
const PrivacyPolicy: React.FC = () => {
  const { t, i18n } = useTranslation();
  /** 日本語版のURL。 */
  const urlJa = 'https://www.ana.co.jp/ja/jp/share/privacy/';
  /** 英語版のURL。 */
  const urlEn = 'https://www.ana.co.jp/en/jp/common/aboutana/legal/';
  /** リンクとして設定するURL。 */
  // 言語設定に応じてリンク先を切り替える。
  const url = isJapanese(i18n.language) ? urlJa : urlEn;
  return (<ExternalLink url={url} label={t('privacy_policy')} />);
};

export default PrivacyPolicy;
